import { useState, useEffect, useRef } from "react";
import {
  Box,
  Container,
  Flex,
  Image,
  Heading,
  Text,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  FormControl,
  Link,
} from "@chakra-ui/react";
import TitleSpoleto from "../Title";
import SubTitle from "../SubTitle";
import { createPortal } from "react-dom";
import ZoomImage from "./ZoomImage";
import { disableBodyScroll, enableBodyScroll } from "../../utils";
import Swal from "sweetalert2";
import axios from "axios";
import InputMask from "react-input-mask";
import CustomInput from "../FormWrapper/CustomInput";
import SelectedImage from "../../images/Selecionado.png";

const arts = [
  {
    id: 320,
    url: "https://concursopratos2022.spoleto.com.br/finalistas/qCmt8CX4w0YZjE2OAi6Z3sbykL2jKJLv5jLHI6iQ.png",
    userName: "Caick Gomes Carvalho",
    artName: "Ser natureza",
  },
  {
    id: 409,
    url: "https://concursopratos2022.spoleto.com.br/finalistas/oYvAst5FA7Z1L6QXCLSu1yr0tiPMgxfz54IUueLr.png",
    userName: "Girresse Araújo Rodrigues Ribeiro",
    artName: "Biomas do Brasil",
  },
  {
    id: 101,
    url: "https://concursopratos2022.spoleto.com.br/finalistas/ORT731eHexBrJ7aY0CtNe9BYV0Yreeu7BOUy49Ec.png",
    userName: "Alexandre de Melo",
    artName: "A Massa da vida",
  },
  {
    id: 95,
    url: "https://concursopratos2022.spoleto.com.br/finalistas/B5xRdfIUani5a5isinHlXQWqA5EBAjz8kQtp2xoD.png",
    userName: "Tamires de Lima Pereira",
    artName: "Minha gaiola é a imensidão do mundo",
  },
  {
    id: 66,
    url: "https://concursopratos2022.spoleto.com.br/finalistas/ktPCwryWSz0lDSV20xNZEEU41yIYi38n2cVG8pOk.png",
    userName: "Tamires de Lima Pereira",
    artName: "Jardim Secreto",
  },
  {
    id: 255,
    url: "https://concursopratos2022.spoleto.com.br/finalistas/iakfGrYR5WYydKtdZcnNbfhBPXLpd7XqZdK0lM7F.png",
    userName: "Jonata Antonio Duarte",
    artName: "O Ouro do Brasil",
  },
  {
    id: 61,
    url: "https://concursopratos2022.spoleto.com.br/finalistas/cNgQ45EV4Ei2wplBc9Nv2AlIo8vRW6t7uXgZT29J.png",
    userName: "Patricia Perez de Moraes Barbosa",
    artName: "Nest - Você atrai vida",
  },
  {
    id: 15,
    url: "https://concursopratos2022.spoleto.com.br/finalistas/hr4CA2PMadzDdklBNpeFADcFsO6WMjQzZKk8LQql.png",
    userName: "Mariline Nacarate Alves",
    artName: "Koi",
  },
];

const Vote = () => {
  const [show, setShow] = useState(false);
  const [voteLoading, setVoteLoading] = useState(false);
  const [voteIsDone, setVoteIsDone] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalConfirmIsOpen, setModalConfirmIsOpen] = useState(false);
  const [phone, setPhone] = useState("");
  const [accept, setAccept] = useState(false);
  const [isSubmited, setIsSubmited] = useState(false);
  const [isModalSuccess, setModalSuccess] = useState(false);
  const [selectedArts, setSelectedArts] = useState([]);

  const initialRef = useRef();

  useEffect(() => {
    if (selectedArts.length === 8) {
      openModalFinishVote();
    }
  }, [selectedArts]);

  const openModalFinishVote = () => {
    setModalIsOpen(true);
  };

  const modalFinishVote = () => {
    if (!modalIsOpen) return null;
    return (
      <>
        <Modal isOpen={modalIsOpen} isCentered>
          <ModalOverlay />
          <ModalContent bg="#E5E5E5">
            <ModalHeader color="#331F12" fontSize="4xl">
              Votação
            </ModalHeader>
            <ModalBody>
              <Text color="#331F12" fontSize="21px">
                Você já selecionou o número máximo permitido de 8 artes. <br />{" "}
                Deseja concluir a votação ou continuar olhando?
              </Text>
            </ModalBody>

            <ModalFooter justifyContent="space-between">
              <Button
                bg="#331F12"
                color="#F5B241"
                fontWeight="normal"
                borderRadius="5px"
                fontSize={["16px", null, "20px"]}
                py={6}
                _hover={{
                  filter: "brightness(0.9)",
                }}
                w="80%"
                mr={2}
                onClick={confirmBeforeSendVote}
                isLoading={voteLoading}
              >
                Votar
              </Button>
              <Button
                bg="gray.300"
                color="#000"
                fontWeight="normal"
                borderRadius="5px"
                fontSize={["16px", null, "20px"]}
                py={6}
                _hover={{
                  filter: "brightness(0.9)",
                }}
                w="100%"
                onClick={() => setModalIsOpen(false)}
                mr={2}
              >
                Continuar olhando
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    );
  };

  const modalConfirmVote = () => {
    if (!modalConfirmIsOpen) return null;
    return (
      <>
        <Modal
          isOpen={modalConfirmIsOpen}
          isCentered
          onClose={() => setModalConfirmIsOpen(false)}
          initialFocusRef={initialRef}
        >
          <ModalOverlay />
          <ModalContent p={8} bg="#EFEBE1" maxWidth={["90%", null, "450px"]}>
            <ModalHeader
              color="#331F12"
              fontSize={["3xl", null, "5xl"]}
              lineHeight={["35px", null, "45px"]}
            >
              CONFIRME <br /> SEU VOTO
            </ModalHeader>
            <ModalBody>
              <Text color="#331F12" fontSize={["18px", null, "21px"]} mb={5}>
                Para validar seu voto <br /> insira seu número de <br />{" "}
                telefone com ddd:
              </Text>
              <Box>
                <FormControl id="phone" flex={1}>
                  <CustomInput
                    placeholder="ex.: (00) 00000-0000"
                    value={phone}
                    as={InputMask}
                    mask="(99) 99999-9999"
                    maskChar={null}
                    fontSize={["18px", null, "25px"]}
                    onChange={(e) => setPhone(e.target.value)}
                    boxShadow="0px 0px 4px #D2BC7B"
                    autoFocus={false}
                    border={!phone && isSubmited && "2px solid #C22424"}
                  />
                  {!phone && isSubmited && (
                    <Text
                      color="#C22424"
                      fontSize="14px"
                      fontWeight="400"
                      mt={1}
                      textAlign="right"
                    >
                      Campo obrigatório
                    </Text>
                  )}
                </FormControl>
              </Box>
              <Flex
                mt={8}
                alignItems="flex-start"
                justifyContent="space-between"
                className="modal-vote-checkbox"
              >
                <input
                  type="checkbox"
                  value={accept}
                  onChange={(e) => setAccept(e.target.checked)}
                />
                <Text ml="20px" fontSize="sm" color="#331F12">
                  Aceito participar do MIO (Programa Fidelidade do Spoleto) que
                  dá cashback nas minhas compras feitas no restaurante e no site
                  oficial).{" "}
                  <Link
                    href="https://www.spoleto.com.br/fidelidade"
                    color="#215342"
                    textDecoration="underline"
                    fontSize={["16px", null, "18px"]}
                    target="_blank"
                  >
                    Conheça aqui.
                  </Link>
                </Text>
              </Flex>
              <Box mt={8}>
                <Button
                  ref={initialRef}
                  bg="#331F12"
                  color="#F5B241"
                  fontWeight="normal"
                  borderRadius="5px"
                  fontSize={["18px", null, "23px"]}
                  py={8}
                  _hover={{
                    filter: "brightness(0.9)",
                  }}
                  _focus={{
                    boxShadow: "none",
                  }}
                  boxShadow="none"
                  w="100%"
                  mr={2}
                  onClick={sendVote}
                  isLoading={voteLoading}
                >
                  Confirmar
                </Button>
              </Box>
            </ModalBody>
          </ModalContent>
        </Modal>
      </>
    );
  };

  const modalSuccess = () => {
    if (!isModalSuccess) return null;
    return (
      <>
        <Modal isOpen={isModalSuccess} isCentered>
          <ModalOverlay />
          <ModalContent p={8} bg="#48BAA8">
            <ModalBody textAlign="center">
              <Image mx="auto" src={SelectedImage} mb="40px" mt="30px" />
              <Text
                color="#331F12"
                fontSize={["34px", null, "45px"]}
                textAlign="center"
                fontWeight="bold"
                mb={5}
                lineHeight="35px"
              >
                SEU VOTO FOI REGISTRADO!
              </Text>
              <Text
                color="#331F12"
                fontSize="24px"
                textAlign="center"
                mt="30px"
                mb="50px"
              >
                Você pode votar um vez por dia até 04/07.
              </Text>
              <Button
                bg="#F5B241"
                borderRadius={4}
                py={8}
                w={["80%", null, null, "100%"]}
                color="#331F12"
                fontSize="24px"
                fontWeight="normal"
                mt={4}
                _hover={{
                  filter: "brightness(0.8)",
                }}
                _focus={{
                  boxShadow: "none",
                }}
                onClick={() => {
                  setModalSuccess(false);
                }}
              >
                Fechar
              </Button>
            </ModalBody>
          </ModalContent>
        </Modal>
      </>
    );
  };

  const selectArt = (id) => {
    if (selectedArts.length <= 7) {
      setSelectedArts([...selectedArts, id]);
    } else {
      return false;
    }
  };

  const finishVoteStep = () => {
    setSelectedArts([]);
  };

  const removeSelect = (e, id) => {
    e.stopPropagation();
    if (selectedArts.includes(id)) {
      const newSelectedArts = selectedArts.filter((item) => item !== id);
      setSelectedArts([...newSelectedArts]);
    } else {
      return false;
    }
  };

  const confirmBeforeSendVote = () => {
    setModalConfirmIsOpen(true);
  };

  const sendVote = () => {
    setIsSubmited(true);
    if (!phone) {
      return false;
    }
    setVoteLoading(true);
    const send = [...selectedArts];
    const payload = { subscriptions: send, phone: phone, optin_check: accept };

    return axios
      .post(
        "https://backendpratos.spoletoitalian.com/api/postpublicvote",
        payload,
        {
          headers: {
            "Content-Type": `application/json`,
            Authorization: "Basic ZnJvbnQ6MTkyMzQx",
          },
        }
      )
      .then(function (response) {
        setModalIsOpen(false);
        setVoteLoading(false);
        finishVoteStep();
        setVoteIsDone(true);
        setModalConfirmIsOpen(false);
        window.scrollTo({
          top: 100,
        });
        if (response.data.success) {
          setModalSuccess(true);
        } else {
          Swal.fire({
            icon: "error",
            title: "Você já fez sua votação hoje.",
            text: "Você poderá votar novamente 24horas após o seu ultimo voto.",
          });
        }
      })
      .catch(function (error) {
        setModalIsOpen(false);
        setVoteLoading(false);
        finishVoteStep();
        setModalConfirmIsOpen(false);
        setModalSuccess(false);
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Algo deu errado",
          text: "Desculpe, estamos com um problema para processar a sua votação mas já estamos trabalhando para resolver o mais rápido possível.",
        });
      });
  };

  const closeZoomImage = () => {
    setShow(false);
    enableBodyScroll();
  };

  const zoomImage = () => {
    if (!show) return null;
    let modalWrapper = document.querySelector(".modal-zoom-wrapper");

    if (!modalWrapper) {
      modalWrapper = document.createElement("div");
      modalWrapper.className = "modal-zoom-wrapper";
    }

    document.body.appendChild(modalWrapper);
    disableBodyScroll();
    return createPortal(
      <ZoomImage onClose={closeZoomImage} url={show} />,
      modalWrapper
    );
  };

  const openZoomImage = (item) => {
    if (selectedArts.includes(item.id)) return false;
    setShow(item.url);
  };

  return (
    <Box bg="#EFEBE1" py={10} id="votacao">
      {zoomImage()}
      {modalFinishVote()}
      {modalConfirmVote()}
      {modalSuccess()}
      {/* {voteIsDone ? (
        <>
          <TitleSpoleto color="#5B3923">
            Obrigado pela sua participação
          </TitleSpoleto>
          <SubTitle mt={2} color="#5B3923">
            O seu voto foi realizado com sucesso. <br /> O resultado estará
            disponível neste site dia 08/07.
          </SubTitle>
        </>
      ) : (
        <>
          <TitleSpoleto color="#5B3923">Votação</TitleSpoleto>
          <SubTitle mt={2} color="#5B3923">
            Vote em até 8 pratos que você gostaria <br /> que fossem da coleção
            de 2022!
          </SubTitle>
          <Container maxW="container.xl" mt={16}>
            <Flex
              w="100%"
              flexDirection={["column", null, null, "row"]}
              justifyContent="center"
              flexWrap="wrap"
              alignItems="flex-end"
            >
              {arts.map((item, index) => (
                <Box
                  w={["100%", null, null, "31%"]}
                  my="10px"
                  key={item.id}
                  py={8}
                  px={12}
                  borderRadius="25px"
                  transition="all .3s ease-in-out"
                  borderColor={
                    selectedArts.includes(item.id) ? "#331F12" : "transparent"
                  }
                  borderWidth={selectedArts.includes(item.id) ? "2px" : "2px"}
                  cursor={selectedArts.includes(item.id) ? "pointer" : "auto"}
                  onClick={(e) => removeSelect(e, item.id)}
                  pos="relative"
                  mx={["auto", null, null, "10px"]}
                >
                  {selectedArts.includes(item.id) ? (
                    <Image
                      src="/assets/images/selected-black.png"
                      pos="absolute"
                      right="20px"
                      top="20px"
                    />
                  ) : null}
                  <Box>
                    <Image
                      src={item.url}
                      mb={4}
                      mx="auto"
                      cursor="zoom-in"
                      onClick={() => openZoomImage(item)}
                    />
                    <Heading fontSize="xl" color="#000">
                      {item.userName}
                    </Heading>
                    <Text fontSize="md" color="#331F12">
                      {item.artName}
                    </Text>
                    {!selectedArts.includes(item.id) ? (
                      <Button
                        bg="#F5B241"
                        borderRadius={4}
                        w={["80%", null, null, "100%"]}
                        color="#331F12"
                        mt={4}
                        _hover={{
                          filter: "brightness(0.8)",
                        }}
                        _disabled={{
                          opacity: "0.5",
                          cursor: "not-allowed",
                        }}
                        _focus={{
                          boxShadow: "none",
                        }}
                        boxShadow="none"
                        disabled={
                          selectedArts.includes(item.id) ||
                          selectedArts.length === 8
                        }
                        cursor={
                          selectedArts.includes(item.id)
                            ? "not-allowed"
                            : "pointer"
                        }
                        onClick={() => selectArt(item.id)}
                      >
                        Curti
                      </Button>
                    ) : (
                      <Button
                        bg="#E4DDCB"
                        borderRadius={4}
                        w={["80%", null, null, "100%"]}
                        color="#000"
                        mt={4}
                        _hover={{
                          filter: "brightness(0.9)",
                        }}
                        _focus={{
                          boxShadow: "none",
                        }}
                        _disabled={{
                          opacity: "0.8",
                        }}
                        boxShadow="none"
                        onClick={(e) => removeSelect(e, item.id)}
                      >
                        Cancelar
                      </Button>
                    )}
                  </Box>
                </Box>
              ))}
            </Flex>
            <Button
              bg="#331F12"
              color="#F5B241"
              fontWeight="normal"
              borderRadius="5px"
              width="100%"
              maxWidth="450px"
              h={["50px", null, "70px"]}
              fontSize={["20px", null, "32px"]}
              mb={4}
              mt={16}
              _hover={{
                filter: "brightness(0.9)",
              }}
              mx="auto"
              disabled={!selectedArts.length}
              cursor={!selectedArts.length ? "not-allowed" : "pointer"}
              onClick={confirmBeforeSendVote}
              isLoading={voteLoading}
            >
              Votar
            </Button>
          </Container>
        </>
      )} */}
      <TitleSpoleto color="#5B3923">Resultado</TitleSpoleto>
      <SubTitle mt={2} color="#5B3923">
        Conheça os 8 grandes vencedores do <br /> concurso!
      </SubTitle>
      <Container maxW="container.xl" mt={16}>
        <Flex
          w="100%"
          flexDirection={["column", null, null, "row"]}
          justifyContent="center"
          flexWrap="wrap"
          alignItems="flex-end"
        >
          {arts.map((item, index) => (
            <Box
              w={["100%", null, null, "31%"]}
              my="10px"
              key={item.id}
              py={8}
              px={12}
              borderRadius="25px"
              transition="all .3s ease-in-out"
              borderColor="transparent"
              borderWidth="2px"
              cursor="auto"
              pos="relative"
              mx={["auto", null, null, "10px"]}
            >
              <Box>
                <Image
                  src={item.url}
                  mb={4}
                  mx="auto"
                  cursor="zoom-in"
                  onClick={() => openZoomImage(item)}
                />
                <Heading fontSize="xl" color="#5B3923">
                  {item.userName}
                </Heading>
                <Text fontSize="md" color="#000">
                  {item.artName}
                </Text>
              </Box>
            </Box>
          ))}
        </Flex>
      </Container>
    </Box>
  );
};

export default Vote;
